import { JsonPipe } from "@angular/common";
import { Component } from "@angular/core";
import { ApiSpecificationModel } from "@app/manual/models/api-models/api-specification-model";
import { ApiSpecComponent } from "../../api-spec";

@Component({
    selector: "app-thirdparty-create-thirdpartycontract-api-manual",
    templateUrl: "../../api-spec.html",
    styleUrls: ["../../api-spec.scss"],
    standalone: true,
    imports: [JsonPipe],
})
export class ThirdpartyContractCreateApiManualComponent extends ApiSpecComponent {
    initSpecs() {
        return <ApiSpecificationModel>{
            name: "Create New Third Party Contract",
            description: "This endpoint can be used to create a new third party contract.",
            httpMethod: "POST",
            path: "/thirdpartycontract",

            parameters: [
                {
                    name: "Contractnumber",
                    description: "Contract number of the third party contract to create",
                    in: "body",
                    paramType: "string",
                    required: true,
                    example: "third party contract to create contract number",
                },
                {
                    name: "ContractedValue",
                    description: "ContractedValue of the third party contract to create",
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 12345,
                },
                {
                    name: "StatusId",
                    description: "Status Id of the third party contract to create",
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 1,
                },
                {
                    name: "TermOfNoticeQuantity",
                    description:
                        "Term of notice quantity of the third party contract to create. Term of notice quantity is required when the term of notice period is day, week or month",
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 3,
                },
                {
                    name: "TermOfNoticePeriod",
                    description:
                        "Term of notice period of the third party contract to create. Available options are: 1 for None, 2 for Day, 3 for Week, and 4 for Month",
                    in: "body",
                    paramType: "integer",
                    required: true,
                    example: 1,
                },
                {
                    name: "SignatureDate",
                    description: "Signature date of the third party contract to create",
                    in: "body",
                    paramType: "date",
                    required: false,
                    example: "2025-01-31",
                },
                {
                    name: "StartDate",
                    description: "Start date of the third party contract to create",
                    in: "body",
                    paramType: "date",
                    required: false,
                    example: "2025-02-01",
                },
                {
                    name: "EndDate",
                    description: "End date of the third party contract to create",
                    in: "body",
                    paramType: "date",
                    required: false,
                    example: "2025-02-28",
                },
                {
                    name: "AnnualValue",
                    description: "The annual value of the third party contract to create",
                    in: "body",
                    paramType: "integer",
                    required: false,
                    example: 1234567890,
                },
                {
                    name: "Framework",
                    description:
                        "Whether the third party contract to create is a framework contract. If omitted defaults to false",
                    in: "body",
                    paramType: "boolean",
                    required: false,
                    example: true,
                },
                {
                    name: "ThirdPartyGuid",
                    description:
                        "The uuid of the third party to which the third party contract is linked",
                    in: "body",
                    paramType: "uuid",
                    required: true,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "ContractOwner",
                    description:
                        "The uuid of the user to set as the contract owner of the third party contract",
                    in: "body",
                    paramType: "uuid",
                    required: false,
                    example: "00000000-0000-0000-0000-000000000000",
                },
                {
                    name: "CurrencyCode",
                    description:
                        "The ISO 4217 currency code of the currency of the third party contract",
                    in: "body",
                    paramType: "string",
                    required: false,
                    example: "EUR",
                },
                {
                    name: "Services",
                    description: "The id's for the services to set for the third party contract",
                    in: "body",
                    paramType: "array of integers",
                    required: false,
                    example: [1, 2],
                },
                {
                    name: "CustomFields",
                    description:
                        "The custom fields to set for the third party. CustomFieldGuid and Value both are required. Value is always a string, but can represent a comma separated list of optionIds, a single optionId, an actual string, or a date value depending on the type of custom field being filled",
                    in: "body",
                    paramType: "array of models",
                    required: false,
                    example: [
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000000",
                            Value: "1,2",
                        },
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000001",
                            Value: "1",
                        },
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000002",
                            Value: "api custom field text",
                        },
                        {
                            CustomFieldGuid: "00000000-0000-0000-0000-000000000004",
                            DateValue: "2025-03-15",
                        },
                    ],
                },
            ],

            responses: [
                {
                    code: "200",
                    description: "OK",
                    example: "00000000-0000-0000-0000-000000000000",
                },
            ],
        };
    }
}
